import { Box, Flex, SystemStyleObject } from '@chakra-ui/react';
import { HyperlinkIcon, TRANSITIONS, useIsClient } from '@cyberkongz/ui';
import { ReactNode, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';

export function CopyUrl({
  icon,
  textToCopy,
  sxMessageBox,
}: {
  textToCopy?: string;
  icon?: ReactNode;
  sxMessageBox?: SystemStyleObject;
}) {
  const isClient = useIsClient();
  const [copied, setCopied] = useState(false);

  return isClient ? (
    // @ts-ignore
    <CopyToClipboard
      text={textToCopy || window.location.href}
      onCopy={() => {
        setCopied(true);

        setTimeout(() => {
          setCopied(false);
        }, 2000);
      }}
    >
      <Flex cursor="pointer" position="relative" alignItems="center">
        {icon || <HyperlinkIcon />}
        <Box
          css={{
            bg: 'backgroundSecondary',
            position: 'absolute',
            width: '6em',
            textAlign: 'center',
            borderRadius: 'sm',
            fontSize: 'xs',
            fontWeight: 'medium',
            px: 2,
            py: 1,
            opacity: copied ? 1 : 0,
            visibility: copied ? 'visible' : 'hidden',
            transition: `visibility 0s, opacity ${TRANSITIONS.standard}`,
            transform: 'translateY(10%)',
            ...sxMessageBox,
          }}
        >
          Copied to clipboard
        </Box>
      </Flex>
    </CopyToClipboard>
  ) : null;
}
